import { containsVideoExtension } from '@features/logs/utils/incidentUtils'

// Signed S3 links carry a long query string, so only the path says what the
// file actually is.
const pathOf = (url: string) => url.split('?')[0]

/**
 * The URL to draw as a video's thumbnail, or undefined when there isn't a
 * usable one and the caller should fall back to the placeholder.
 *
 * ROST-3625: stock logs come back with `videoThumbnail` set to the uploaded
 * video itself — a `.mov` under `medication-media/` — because nothing generates
 * a still frame on that upload path. An `<img>` pointed at a video renders as a
 * broken image, so a video URL here means "no thumbnail".
 */
export const getVideoThumbnailUrl = (
  videoThumbnail?: string | null
): string | undefined => {
  if (!videoThumbnail || containsVideoExtension(pathOf(videoThumbnail))) {
    return undefined
  }
  return videoThumbnail
}
